// apps/web/src/dashboards/data-oracle/manifest.ts
// The standalone Data Oracle dashboard (/oracle) — a peer of Brief / AMM /
// Signal-History / Operations (design doc §9, decision 7 revised 2026-07-14).
// The price surfaces (Consensus / Sources / Policy / Runs, one GET
// /api/oracle bundle) are followed by MACRO — the second data_type, reading its own
// GET /api/oracle/macro bundle (P4, 2026-07-14) — RELATIONS, the wrapped-token depeg
// monitor (GET /api/oracle/relations, P2.5 5.2) — and NEWS, the third data_type
// (UNION over news_items + news_processing_log, GET /api/oracle/news, task #75, Shape
// B-flat, design doc §8). NOTE: AUTHORITATIVE is not "the macro mode" — since migration
// 0100 equity price resolves authoritatively too; the CONSENSUS tab renders both modes.

export const DATA_ORACLE_TABS = ['consensus', 'sources', 'lineage', 'policy', 'runs', 'macro', 'relations', 'news'] as const;
export type DataOracleTab = (typeof DATA_ORACLE_TABS)[number];

export interface DataOracleManifest {
  readonly id:    'data-oracle';
  readonly title: string;
  readonly tabs:  ReadonlyArray<DataOracleTab>;
}

export const DATA_ORACLE_MANIFEST: DataOracleManifest = {
  id:    'data-oracle',
  title: 'Data Oracle',
  tabs:  DATA_ORACLE_TABS,
} as const;

export const DATA_ORACLE_TAB_LABELS: Record<DataOracleTab, string> = {
  consensus: 'CONSENSUS',
  sources:   'SOURCES',
  lineage:   'LINEAGE',
  policy:    'POLICY',
  runs:      'RUNS',
  macro:     'MACRO',
  relations: 'RELATIONS',
  news:      'NEWS',
};
